import { ImageResolution } from "./hooks/useImageResizer";

export const SUPPORTED_RESOLUTIONS: ImageResolution[] = [
  ImageResolution.FULL,
  ImageResolution.SMALL
];

interface PhotoResolutionData {
  file?: File;
  uploadedUrl?: string;
  presigned?: {
    url?: string;
    uploadUrl?: string;
    assetId?: string;
  };
}

export interface PhotoWithStatus {
  id: string;
  status: "waiting" | "uploading" | "completed" | "error" | "uploaded";
  resolutions: Record<ImageResolution, PhotoResolutionData>;
  progress?: number;
  previewUrl: string;
}
